<template>
  <div class="tw:md:my-8 tw:md:pl-8 tw:flex tw:flex-col tw:md:gap-y-4">
    <ProToPlusReactivationSidebarCard />
    <SidebarNotification layout="vertical" v-if="!isMobile" />
    <StudioPlusEligibleCard v-if="isStudioPlusEligible" class="tw:hidden tw:md:flex" />
    <StudioPlusActiveCard v-else class="tw:hidden tw:md:flex" />
    <RateConnectEligibleCard v-if="isRateConnectEligible" />
    <PropertyDetailsCard />
    <MoreCard />
  </div>
</template>

<script setup>
import ProToPlusReactivationSidebarCard from '@/components/homePage/sidebar/ProToPlusReactivationSidebarCardContainer.vue'
import StudioPlusEligibleCard from '@/components/homePage/sidebar/StudioPlusEligibleCard.vue'
import StudioPlusActiveCard from '@/components/homePage/sidebar/StudioPlusActiveCard.vue'
import RateConnectEligibleCard from '@/components/homePage/sidebar/RateConnectEligibleCard.vue'
import PropertyDetailsCard from '@/components/homePage/sidebar/PropertyDetailsCard.vue'
import MoreCard from '@/components/homePage/sidebar/MoreCard.vue'
import SidebarNotification from '@/components/productNotifications/sidebarNotifications/SidebarNotification.vue'

import { useIsMobile } from '@/composables/useIsMobile'

const { isMobile } = useIsMobile()
defineProps({
  isStudioPlusEligible: Boolean,
  isRateConnectEligible: Boolean,
})
</script>
